import { render } from "./TrainerCard.vue?vue&type=template&id=12438b70&scoped=true"
import script from "./TrainerCard.vue?vue&type=script&lang=js"
export * from "./TrainerCard.vue?vue&type=script&lang=js"

import "./TrainerCard.vue?vue&type=style&index=0&id=12438b70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12438b70"]])

export default __exports__